module.exports = __webpack_public_path__ + "img/tutorial-slide.55aaf50a.svg";